import { Component, ViewEncapsulation, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-file-uploader',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent {
    public file: any;
    public uploadFile: File;
    // @Output() myEvent = new EventEmitter();

    fileChange(input) {
        const reader = new FileReader();
        if (input.files.length) {
            this.file = input.files[0].name;
            this.uploadFile = input.files[0];
            // this.myEvent.emit(input.files[0]);
        }
    }

    removeFile(): void {
        this.file = '';
        this.uploadFile = undefined;
    }

}



// WEBPACK FOOTER //
// E:/sachin/Project/Masterly_Solutions/Project_HRMS/Hrms_Developer/hrms/Peerless.HRMS.WebUI.EmployeePortal/src/app/pages/employment-application/file-uploader/file-uploader.component.ts